import React from 'react';

function WhyChooseUs() {
  const points = [
    {
      title: 'Practical Solutions',
      icon: '🛠️',
      desc: 'Solutions designed around real business requirements, ensuring pragmatism and measurable outcomes.'
    },
    {
      title: 'Digital Expertise',
      icon: '📊',
      desc: 'Deep specialization in search visibility optimization, targeted advertising, and online business development.'
    },
    {
      title: 'Technology Guidance',
      icon: '💡',
      desc: 'Technical advisory services helping your organization choose the right tech stack, frameworks, and architecture.'
    },
    {
      title: 'Customized Approach',
      icon: '🤝',
      desc: 'Every business has distinct core objectives, processes, and customer landscapes. We tailor solutions for you.'
    },
    {
      title: 'Growth-Focused',
      icon: '🚀',
      desc: 'A strategic partnership model focused on building scalable IT resources to secure long-term revenue gains.'
    }
  ];

  return (
    <div className="page-why-choose-us">
      {/* HEADER */}
      <section className="section">
        <div className="section-header">
          <span className="section-tag">Our Philosophy</span>
          <h2 className="section-title">Technology With a Business Purpose</h2>
          <p className="section-subtitle" style={{ maxWidth: '850px', fontSize: '1.15rem', lineHeight: '1.8' }}>
            We don't believe in technology for the sake of technology. Our approach focuses on understanding the 
            business requirement first and then finding an appropriate digital or technology solution.
          </p>
        </div>
      </section>

      {/* WHY CHOOSE US GRID */}
      <section className="section bg-alt-dark" style={{ borderTop: '1px solid var(--border-color)' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 1.5rem' }}>
          <div className="features-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2.5rem', justifyContent: 'center' }}>
            {points.map((p, index) => (
              <div key={index} className="feature-card" style={{ padding: '2.5rem 2rem' }}>
                <div className="feature-icon-wrapper" style={{ fontSize: '2rem', width: '55px', height: '55px', marginBottom: '1.5rem' }}>{p.icon}</div>
                <h3 className="feature-title" style={{ fontSize: '1.25rem', marginBottom: '0.8rem' }}>{p.title}</h3>
                <p className="feature-desc" style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', lineHeight: '1.6' }}>{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default WhyChooseUs;
